import {
  AppBar,
  Container,
  CssBaseline,
  ThemeProvider,
  Toolbar,
  Typography,
  createTheme,
} from '@mui/material';
import React from 'react';
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
  useNavigate,
} from 'react-router-dom';

import './App.css';
import Checkpoint from './components/Checkpoint';
import Home from './components/Home';
import { CheckpointsProvider } from './lib/CheckpointsContext';

const theme = createTheme({
  palette: {
    primary: {
      main: '#FFDDDD',
    },
    secondary: {
      main: '#FF0000',
    },
  },
});

function AppContent() {
  const navigate = useNavigate();

  return (
    <div className="App">
      <AppBar position="static">
        <Toolbar>
          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1, cursor: 'pointer' }}
            onClick={() => navigate('/')}
          >
            ❤️ Martan Synttärit ❤️
          </Typography>
        </Toolbar>
      </AppBar>
      <Container maxWidth="lg" sx={{ mt: 2 }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/checkpoint/:checkpointId" element={<Checkpoint />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Container>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <CheckpointsProvider>
        <Router>
          <AppContent />
        </Router>
      </CheckpointsProvider>
    </ThemeProvider>
  );
}

export default App;
